module.exports = __webpack_public_path__ + "img/aws-data-exchange-icon.7f493005.svg";